import './style.scss'
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import StateTypes from '../../constants/StateTypes'
import { reportPreviewActions, report } from '../../lossAss/actions'
import NoData from '../../components/NoData';

const userInfoType = StateTypes.app.customers.userInfo;

class CurrentChat extends Component {
	constructor(props) {
		super(props)
		this.state = {
			curCheckStyle: 0
		}
	}
	componentDidMount() {
		const { actions, customer } = this.props
		actions.currentCustomerInfo(customer);
		//actions.saveInfoBut(true)
	}
	handleClick(data) {
		const { actions, customer } = this.props;
		actions.clearChatMessage()
		actions.switchUserInfo(userInfoType.userData)
		actions.isOrNoUserInfo("isUserInfo")
		if (customer.userInfo.flowId) {
			// actions.setCurrentReport('')
			actions.getLatestReport(customer.userInfo.flowId)
			this.props.history.push(`/workBench/ReportDetail/${customer.userInfo.flowId}`)
		}
	}
	render() {
		const { customer } = this.props
		let timeHour = '', timeYear = '', timeDiv
		if (customer && customer.startedAt) {

			timeHour = moment(customer.startedAt).format('HH:mm')
			timeYear = moment(customer.startedAt).format('MM/DD')

		}
		if (timeYear && timeHour) {
			timeDiv = <div className="time-div-history">{timeYear + ' ' + timeHour}</div>
		}
		return <li
			className={`list-item ${(customer.unreadCount ? 'unread' : '')}`}
			onClick={this.handleClick.bind(this, customer._id)}
			key={customer._id}
		>
			<h4>
				<span className="name">{customer.userInfo.carOwner}</span>
				<span className="number">{customer.userInfo.flowId}</span>
			</h4>
			<p className="time">{timeDiv}</p>
		</li>
	}
}
class CurrentChatList extends Component {

	render() {
		const { actions, customers } = this.props;
		return <div className='current-chat-list'>
			<ul className='list'>
				{
					customers && customers.length ? customers.map(customer => <CurrentChat
						key={customer._id}
						customer={customer}
						actions={actions}
						history={this.props.history}
					/>
					) : <NoData />
				}
			</ul>
		</div>
	}
}

/**
 * Default props when OpenChatList isn't passed any prop.
 */
CurrentChatList.defaultProps = {
	count: 0,
	title: '',
	icon: '',
	customers: []
}


let mapDispatchToProps = (dispatch) => {
	return {
		reportPreviewActions: bindActionCreators(Object.assign({},
			reportPreviewActions,
			report
		), dispatch)
	}
};

export default connect(
	null,
	mapDispatchToProps
)(withRouter(CurrentChatList))
